import {
  type DSLValueLegacy,
  IndexDateTypeLegacy,
  type IndexDateVariableLegacy,
} from '@verantos-dev/types-cohorts';

import { getDSLDateForDateValue } from '../utils/getDSLDateForDateValue';

export const transformIndexDateToDsl = ({
  id,
  type,
  indexDateValue,
  indexDateRangeValue,
}: IndexDateVariableLegacy): DSLValueLegacy => {
  if (!type) {
    return {
      id,
      value: '',
    };
  }

  let indexDateTypeLegacy = '';
  let query = '';

  switch (type) {
    case IndexDateTypeLegacy.CALENDAR: {
      indexDateTypeLegacy = 'CALENDAR_DATE';

      if (indexDateValue) {
        query = getDSLDateForDateValue(indexDateValue);
      }
      break;
    }
    case IndexDateTypeLegacy.EVENT: {
      indexDateTypeLegacy = 'EVENT';
      query = indexDateValue;
      if (indexDateRangeValue?.startDate && indexDateRangeValue?.endDate) {
        query += `,LOWER_DATE_BOUND(${getDSLDateForDateValue(
          indexDateRangeValue.startDate
        )}),UPPER_DATE_BOUND(${getDSLDateForDateValue(indexDateRangeValue.endDate)})`;
      }
      break;
    }
  }
  return {
    id,
    value: `INDEX_DATE = ${indexDateTypeLegacy} ( ${query} ) ;`,
  };
};
